<template>
<div>

<div class="yo-text-normal" style="margin:20px 0;padding:0;">

   <div v-if="mylogin && $teras.app.auth" class="yo-bg-color-tertiary yo-text-l yo-text-bold yo-color-secondary" style="padding:8px 24px;margin-bottom:10px;">Ti potrebbe interessare</div>
   <div v-else class="yo-bg-color-tertiary yo-text-l yo-text-bold yo-color-secondary" style="padding:8px 24px;margin-bottom:20px;">{{$lang.g('inEvidenza')}}</div>


   <div class="row pad eventi-box" v-if="false && this.$teras._nextevento.length>3">


      <div v-for="item in scelti" :key="item.id" class="col s12 m4 " style="background:#fff;">
         <div style="padding:20px;">
            <div style="min-height:80px;overflow:hidden;">
               <div class="titolo yo-text-bold">{{item.titolo}}</div>
               <div class="sottotitolo">{{item.citta}},
               <span class="row yo-text-n yo-spacing-s " v-if="item.iniziail==item.finisceil">{{item.finisceil | data('DD MMMM YYYY')}}</span>
               <span class="row yo-text-n yo-spacing-s " v-if="item.iniziail!=item.finisceil">{{item.iniziail | data('DD MMMM')}} - {{item.finisceil | data('DD MMMM YYYY')}}</span>
               </div>
            </div>
            <div class="" style="width:100%;height:230px;">
               <div class="yo-bg-cover" style="height:100%;width:100%;border:2px solid #379EC2;" :style="{'background-image': 'url('+$teras.bventUrl+item.id+'/'+item.imgcitta+')'}"></div>
            </div>
            <router-link :to="'/evento-home/'+item.id" class="yo-block yo-align-right yo-text-bold">Iscriviti</router-link>
         </div>
      </div>
      
<!--   
      <div class="col s12 m4 " style="background:#fff;border-right:10px solid #379EC2;border-left:10px solid #379EC2;">
         <div style="padding:20px;">
            <div style="min-height:80px;overflow:hidden;">
               <div class="titolo yo-text-bold">19° Congresso Nazionale della Società di Allergologia e Immunologia Pediatrica</div>
               <div class="sottotitolo">FIRENZE, 4­ - 6 maggio 2017</div>
            </div>
            <div class="" style="width:100%;height:230px;">
               <div class="yo-bg-cover" style="height:100%;width:100%;border:2px solid #379EC2;" :style="{'background-image': `url(${require('../assets/test-citta.png')})`}"></div>
            </div>
            <a href="#" class="yo-block yo-align-right">Iscriviti</a>
         </div>
      </div>

      <div class="col s12 m4" style="background:#fff;border-right:10px solid #379EC2;border-left:10px solid #379EC2;">
         <div style="padding:20px;">
            <div style="min-height:80px;overflow:hidden;">
               <div class="titolo yo-text-bold">20° CONGRESSO NAZIONALE DELLA SIAIP</div>
               <div class="sottotitolo">MATERA, 30 novembre - ­2 dicembre 2017</div>
            </div>
            <div class="" style="width:100%;height:230px;">
               <div class="yo-bg-cover" style="height:100%;width:100%;border:2px solid #379EC2;" :style="{'background-image': 'url('+$teras.bventUrl+'/2267/siaip.png)'}"></div>
            </div>
            <a href="#" class="yo-block yo-align-right">Iscriviti</a>
         </div>
      </div>

      <div class="col s12 m4" style="background:#fff;border-right:10px solid #379EC2;border-left:10px solid #379EC2;">
         <div style="padding:20px;">
            <div style="min-height:80px;overflow:hidden;">
               <div class="titolo yo-text-bold">XXIII Congresso Nazionale della Società Italiana di Neonatologia</div>
               <div class="sottotitolo">Milano, 25 - ­28 settembre 2017</div>
            </div>
            <div class="" style="width:100%;height:230px;">
               <div class="yo-bg-cover" style="height:100%;width:100%;border:2px solid #379EC2;" :style="{'background-image': 'url('+$teras.bventUrl+'/999/milano.png)'}"></div>
            </div>
            
            <a href="#" class="yo-block yo-align-right">Iscriviti</a>
         </div>
      </div>
-->
   </div>

</div>
  <!-- BARRA DI NAVIGAZIONE MY LOGIN -->
  <headbar v-if="mylogin && $teras.app.auth"></headbar>


</div>
</template>

<script>
import headbar from '../components/Mylogin-headbar'

export default {
   name: 'home',
   props: {
      mylogin: Boolean
   },
   components: {
         headbar
   },
   computed: {
      scelti: function () {
         var itemFilter = []
         var items = {}

         if(this.$teras.app.auth){
            //items = this.$teras.shuffle(this.$contatto._nextevento)
            items = this.$teras.shuffle(this.$teras._nextevento)
         }else{
            items = this.$teras.shuffle(this.$teras._nextevento)
         }
         
         if(typeof items != 'undefined'){
            for (let item of [items[0],items[1],items[2]]){
               itemFilter.push(item) 
               if(itemFilter.length==3)
                  break;
            }
         }
         return itemFilter
      }
   }

   


}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/Eventi-interesse.vue